// extracted by mini-css-extract-plugin
export var blue = "_f-f";
export var brand = "_f-b";
export var darkGrey = "_f-e";
export var disabled = "_f-4";
export var disabledSubtle = "_f-5";
export var error = "_f-6";
export var green = "_f-g";
export var grey = "_f-d";
export var icon = "_f-0";
export var inherit = "_f-a";
export var lightGrey = "_f-c";
export var orange = "_f-i";
export var pink = "_f-k";
export var primary = "_f-1";
export var purple = "_f-l";
export var red = "_f-j";
export var secondary = "_f-2";
export var success = "_f-9";
export var tertiary = "_f-3";
export var warning = "_f-7";
export var warningSecondary = "_f-8";
export var white = "_f-m";
export var yellow = "_f-h";